module.exports = __webpack_public_path__ + "img/Credit Agricole .aecc1814.png";